module.exports = __webpack_public_path__ + "img/res_layout1.178e15cf.png";